@if (
  initialized && (operation === 'read' || operation === 'delete' || readonly)
) {
  @if (!hidden) {
    <ng-container>
      <div
        [id]="uid"
        [class.dcf-disabled]="
          ['inventedName', 'nameMedicinalProduct'].includes(name) && !value
        "
      >
        <ion-item
          [id]="name"
          [class]="'dcf-input-item ' + operation + ' ' + className"
          #component
        >
          <ion-label>
            {{ label | translate }}
            <br />
            <ion-text>{{ value }}</ion-text>
          </ion-label>
        </ion-item>
      </div>
    </ng-container>
  }
} @else {
  @if (formControl) {
    <div [formGroup]="multiple ? activeFormGroup : formControl.parent">
      <div
        [id]="uid"
        #container
        [class]="'dcf-input-item ' + operation + ' ' + className"
        [class.dcf-field-required]="required"
        [class.dcf-field-readonly]="readonly || disabled"
      >
        @if (type === HTML5InputTypes.SELECT) {
          <div [class.dcf-disabled]="disabled">
            <ion-select
              (ionInput)="handleModalChildChanges()"
              (ionChange)="handleModalChildChanges()"
              [id]="name"
              toggleIcon="chevron-down-outline"
              expandedIcon="chevron-up-outline"
              [mode]="'md'"
              (click)="openSelectOptions($event, interface)"
              [hidden]="hidden || !options?.length"
              [labelPlacement]="labelPlacement"
              [label]="label | translate"
              [value]="value"
              (ionChange)="handleChange($event)"
              [fill]="fill"
              [placeholder]="placeholder | translate"
              [formControlName]="name"
              [interface]="interface"
              #component
            >
              @if (options?.length) {
                @for (
                  option of options;
                  track trackItemFn($index, option.text)
                ) {
                  <ion-select-option
                    [value]="option.value"
                    [class.dcf-disabled]="option.disabled"
                    [class.dcf-hidden]="option.hidden"
                    [hidden]="option.hidden"
                  >
                    {{ option.text }}
                  </ion-select-option>
                }
              }

              @if (value?.length && required !== true) {
                <ion-button
                  fill="clear"
                  (click)="handleClearValue($event)"
                  slot="end"
                  aria-label="Clean selection"
                >
                  <ngx-decaf-icon
                    size="small"
                    slot="icon-only"
                    [name]="'ti-input-x'"
                  />
                </ion-button>
              }
            </ion-select>
            @if (initialized && operation === OperationKeys.CREATE) {
              <!-- options?.length
                    ? getErrors(container)
                    : ('errors.empty_options' | translate: { '0': name }) -->
              <div
                class="dcf-error"
                [class.dcf-options-error]="!options?.length"
                [innerHTML]=""
              ></div>
            }
          </div>
        } @else {
          <ion-input
            (ionInput)="handleModalChildChanges()"
            (ionChange)="handleModalChildChanges()"
            [id]="name"
            [type]="type"
            [mode]="'md'"
            [hidden]="hidden"
            [inputmode]="inputmode"
            [labelPlacement]="labelPlacement"
            [minlength]="minlength !== undefined ? minlength : null"
            [maxlength]="maxlength !== undefined ? maxlength : null"
            [readonly]="readonly !== undefined ? readonly : null"
            [max]="max !== undefined ? max : null"
            [min]="min !== undefined ? min : null"
            [pattern]="pattern !== undefined ? pattern : null"
            [step]="step !== undefined ? step : null"
            [fill]="fill"
            [placeholder]="placeholder | translate"
            [label]="label | translate"
            #component
          />
        }
      </div>
    </div>
  } @else {
    <div>
      <p class="dcf-error">
        {{ 'errors.form.control' | translate: { '0': name } }}
      </p>
    </div>
  }
}
